export default __webpack_public_path__ + "static/media/img_papaground06.ac86d432.jpg";